/**
 * ps_account_nav.js
 * En responsive (< 1200px) la nav « Mon compte » passe AU-DESSUS du contenu → le long menu
 * vertical (10 entrées) prend trop de place. On le transforme en LISTE DÉROULANTE : un bouton
 * (libellé = page courante) replie/déplie le menu. Sur desktop (≥1200) le menu reste visible
 * (le bouton est masqué en CSS).
 */
(function () {
	function init() {
		var nav = document.querySelector( '.woocommerce-MyAccount-navigation' );
		if ( ! nav ) {
			return;
		}
		var menu = nav.querySelector( '.pdw-account-menu' );
		if ( ! menu || nav.querySelector( '.pdw-account-nav-toggle' ) ) {
			return;
		}

		// ⚠️ Sur la page « Liste d'achat » (/purchase-list/?id=…), B2BKing NE marque PAS l'item
		//    de menu actif → on force « Listes d'achat » (surlignage + libellé du toggle), sauf si
		//    un item est déjà actif (ex. /bulkorder/ → « Commande en vrac »).
		if ( /\/purchase-list/.test( window.location.pathname ) && ! nav.querySelector( 'li.is-active' ) ) {
			var plLink = nav.querySelector( '.woocommerce-MyAccount-navigation-link--purchase-lists' );
			if ( plLink ) {
				plLink.classList.add( 'is-active' );
			}
		}

		// Libellé = entrée active (page courante), sinon « Menu du compte ».
		var active = nav.querySelector( 'li.is-active a, li.current a, li.is-active, .is-active a' );
		var label = ( active && active.textContent.trim() ) || 'Menu du compte';

		var btn = document.createElement( 'button' );
		btn.type = 'button';
		btn.className = 'pdw-account-nav-toggle';
		btn.setAttribute( 'aria-expanded', 'false' );
		btn.innerHTML = '<span class="pdw-account-nav-toggle-label">' + label + '</span>';

		menu.parentNode.insertBefore( btn, menu );

		btn.addEventListener( 'click', function () {
			var open = nav.classList.toggle( 'pdw-nav-open' );
			btn.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
		} );

		// Referme après un clic sur une entrée (navigation).
		menu.addEventListener( 'click', function ( e ) {
			if ( e.target.closest( 'a' ) ) {
				nav.classList.remove( 'pdw-nav-open' );
			}
		} );
	}

	if ( document.readyState !== 'loading' ) {
		init();
	} else {
		document.addEventListener( 'DOMContentLoaded', init );
	}
})();
